<template>
  <div class="shop-info-page">
    <!-- 顶部标题 -->
    <div class="page-header">
      <!-- <h1 class="page-title">领班人广告连锁</h1>
      <p class="page-subtitle">中国广告行业领军品牌</p> -->
      <img src='@/assets/head1.png'>
    </div>

    <!-- 店铺列表 -->
    <div class="shop-list">
      <!-- 单个店铺卡片 -->
      <div class="shop-card" v-for="(shop, index) in shops" :key="index">
        <div class="shop-header">
          <h2 class="shop-name">{{ shop.name }}</h2>
          <div class="shop-tag" :class="{'is-flagship': shop.isFlagship}">
            {{ shop.tag }}
          </div>
        </div>

        <div class="shop-details">
          <!-- 店铺地址 -->
          <div class="info-item">
            <div class="info-icon">
              <svg viewBox="0 0 24 24">
                <path fill="#012db2" d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"/>
              </svg>
            </div>
            <div class="info-content">
              <h3>店铺地址</h3>
              <p>{{ shop.address }}</p>
            </div>
          </div>

          <!-- 营业时间 -->
          <div class="info-item">
            <div class="info-icon">
              <svg viewBox="0 0 24 24">
                <path fill="#012db2" d="M12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6A7,7 0 0,1 19,13A7,7 0 0,1 12,20M12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22A9,9 0 0,0 21,13A9,9 0 0,0 12,4M12.5,8H11V14L15.75,16.85L16.5,15.62L12.5,13.25V8M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72Z"/>
              </svg>
            </div>
            <div class="info-content">
              <h3>营业时间</h3>
              <p>{{ shop.businessHours }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ContactEdit } from 'vant';

import {getShops} from '../api/mobile'

export default {
  name: 'ShopInfo',
  data() {
    return {
      shops: []
    }
  },
  mounted(){
    this.getAllShops()
  },
  methods: {
    makeCall(phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    },

    getAllShops(){
      getShops().then(res => {
        if(res.code == 1)
        {
          this.shops = []
          res.data.forEach(element => {
            this.shops.push({
              name: element.ShopName,
              address: element.ShopAddress,
              businessHours:element.BusinessHours,
              tag: '加盟店',
              isFlagship:true
            })
          });
        }
      })
    }
  }
}
</script>

<style scoped>
/* 基础样式 */
.shop-info-page {
  padding: 0px;
  background-color: #f5f7fa;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

/* 页面标题 */
.page-header {
  margin-bottom: 10px;
  text-align: center;
  background-color: rgb(238, 238, 238);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.page-header img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.page-title {
  font-size: 22px;
  color: #012db2;
  margin-bottom: 8px;
  font-weight: 600;
}

.page-subtitle {
  font-size: 14px;
  color: #012db2;
  margin: 0;
  opacity: 0.8;
}

/* 店铺列表 */
.shop-list {
  display: flex;
  flex-direction: column;
  padding: 5px;
  padding-bottom: 20px;
  gap: 15px;
}

/* 店铺卡片 */
.shop-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  overflow: hidden;
  border: 1px solid #ffec01;
}

.shop-header {
  padding: 15px;
  border-bottom: 1px solid #ffec01;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffec01;
}

.shop-name {
  font-size: 18px;
  color: #012db2;
  margin: 0;
  font-weight: 600;
}

.shop-tag {
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 10px;
  background: #e6e9ed;
  color: #012db2;
  border: 1px solid #012db2;
}

.shop-tag.is-flagship {
  background: #012db2;
  color: #ffec01;
  border: 1px solid #012db2;
}

/* 信息项 */
.shop-details {
  padding: 0 15px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid rgba(1, 45, 178, 0.1);
}

.info-item:last-child {
  border-bottom: none;
}

.info-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-content {
  flex: 1;
}

.info-content h3 {
  font-size: 15px;
  color: #012db2;
  margin: 0 0 5px 0;
  font-weight: 500;
}

.info-content p {
  font-size: 13px;
  color: #012db2;
  margin: 0;
  opacity: 0.9;
}

/* 点击电话特效 */
.info-item[onclick] {
  cursor: pointer;
  transition: background-color 0.2s;
}

.info-item[onclick]:active {
  background-color: rgba(255, 236, 1, 0.2);
}

/* 响应式调整 */
@media (min-width: 375px) {
  .page-title {
    font-size: 24px;
  }
  
  .shop-name {
    font-size: 20px;
  }
}

@media (min-width: 414px) {
  
  .shop-card {
    margin-bottom: 20px;
  }
}
</style>